/**
 * 根据环境获取链接基础URL
 * 环境说明：
 * - dev-cn: 开发环境-国内
 * - dev-overseas: 开发环境-海外
 * - prod-cn: 生产环境-国内
 * - prod-overseas: 生产环境-海外
 */
function getLinkBaseUrl() {
  // 获取环境变量（webpack DefinePlugin会将字符串值注入，需要去掉引号）
  const buildEnv = (process.env.BUILD_ENV || '').replace(/"/g, '').toLowerCase()
  
  // 根据BUILD_ENV直接判断环境类型
  // 支持格式：dev-cn, dev-overseas, prod-cn, prod-overseas
  let baseUrl = ''
  if (buildEnv.includes('prod')) {
    // 生产环境
    if (buildEnv.includes('overseas') || buildEnv.includes('oversea')) {
      baseUrl = 'https://link.one2sleep.ai'
    } else {
      baseUrl = 'https://link.difint.com'
    }
  } else {
    // 开发环境（默认或dev开头）
    if (buildEnv.includes('overseas') || buildEnv.includes('oversea')) {
      baseUrl = 'https://link2-difint-com.st1.2345.cn'
    } else {
      baseUrl = 'http://link-difint-com.st1.2345.cn'
    }
  }
  
  return baseUrl
}

/**
 * 获取完整的链接URL
 * @param {string} path - 链接路径，如 '/fw/0002'
 * @returns {string} 完整的URL
 */
export function getLinkUrl(path) {
  const baseUrl = getLinkBaseUrl()
  // 确保path以/开头
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${baseUrl}${normalizedPath}`
}

export default {
  getLinkUrl,
  getLinkBaseUrl
}




// WEBPACK FOOTER //
// ./src/utils/linkConfig.js